import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApplications } from '../../provider/ApplicationsContext';

const ApplicationNotification = () => {
  const navigate = useNavigate();
  const { pendingApplicationsCount, showApplicationNotification, dismissNotification } = useApplications();
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsDesktop(window.innerWidth >= 768); // 768px is typical tablet/desktop breakpoint
    };

    // Check initial screen size
    checkScreenSize();

    // Add event listener for window resize
    window.addEventListener('resize', checkScreenSize);

    // Cleanup event listener
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Don't show notification if not desktop, not supposed to show, or no pending applications
  if (!isDesktop || !showApplicationNotification || pendingApplicationsCount === 0) {
    return null;
  }

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <div className="bg-white rounded-lg shadow-lg border border-green-100 overflow-hidden max-w-sm">
        <div className="bg-green-50 px-4 py-2 flex justify-between items-center">
          <div className="flex items-center">
            <div className="bg-[#02B491] rounded-full p-1 mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="white" className="w-4 h-4">
                <path strokeLinecap="round" strokeLinejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
              </svg>
            </div>
            <h3 className="font-medium text-green-800 text-sm">Applications</h3>
          </div>
          <button 
            onClick={dismissNotification} 
            className="text-green-500 hover:text-green-700"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        <div className="p-4">
          <div className="mb-3">
            <div className="flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 mr-2 text-amber-500">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
              </svg>
              <h4 className="font-semibold text-gray-800">
                {pendingApplicationsCount} {pendingApplicationsCount === 1 ? 'Applicant is' : 'Applicants are'} waiting to hear from you!
              </h4>
            </div>
          </div>
          
          <p className="text-sm text-gray-600 mb-4">
            Review your applications now to accept or decline candidates for your roles.
          </p>
          
          <div className="flex justify-end">
            <button
              onClick={dismissNotification}
              className="text-gray-500 hover:text-gray-700 mr-3 text-sm"
            >
              Dismiss
            </button>
            <button
              onClick={() => {
                navigate('/applications');
                dismissNotification();
              }}
              className="bg-[#02B491] hover:bg-[#02a082] text-white px-4 py-2 rounded-md text-sm font-medium transition-colors flex items-center"
            >
              <span>Start interviewing now</span>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 ml-1">
                <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationNotification; 